<div style="padding: 24px;">
    <h3 style="margin: 0 0 16px 0; font-size: 18px; font-weight: 600;">
        {{ dialogData?.title || data?.title }}
    </h3>
    <div style="margin-bottom: 24px; color: #333; line-height: 1.5;">
        {{ dialogData?.message || data?.message }}
    </div>
    <div style="text-align: right;">
        <owc-button (click)="onAccept()" color="primary">
            {{ dialogData?.confirmButtonText || data?.confirmButtonText || 'Accept' }}
        </owc-button>
    </div>
</div>
